module.exports = __webpack_public_path__ + "static/top_users_count-3a184e7a592d5af00cb614d620450421.png";